import { ActionKey, Actions } from 'types/map/action.type';
import { create } from 'zustand';

type MapActionStoreProps = {
  actions: Actions;

  setMapAction: (action: ActionKey, value: boolean) => void;
  resetMapActions: () => void;
};

// 지도관련 액션 상태관리
const useMapActionStore = create<MapActionStoreProps>(set => ({
  actions: {
    navigation: false,
    location: false,
    transport: false,
    indoorTracking: false,
  },

  setMapAction(action, value) {
    set(state => ({
      actions: {
        ...state.actions,
        [action]: value,
      },
    }));
  },

  resetMapActions() {
    set(() => ({
      actions: {
        navigation: false,
        location: false,
        transport: false,
        indoorTracking: false,
      },
    }));
  },
}));

export default useMapActionStore;
